import React from 'react';

import LearnerProfileContent from './components/LearnerProfileContent';
import { LearnerWidgetProps } from './types';

const LearnerProfileDesktop = (props: LearnerWidgetProps) => {
  const { learner, onAction, isCurrentUser } = props;

  return (
    <LearnerProfileContent
      key={learner.status}
      isCurrentUser={isCurrentUser}
      learner={learner}
      onAction={onAction}
    />
  );
};

export default LearnerProfileDesktop;
